import { render, staticRenderFns } from "./ba-tree-picker.vue?vue&type=template&id=6834fe76&scoped=true&"
import script from "./ba-tree-picker.vue?vue&type=script&lang=js&"
export * from "./ba-tree-picker.vue?vue&type=script&lang=js&"
import style0 from "./ba-tree-picker.vue?vue&type=style&index=0&id=6834fe76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834fe76",
  null
  
)

export default component.exports